const SkeletonBlock = ({ className }: { className: string }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

export const ProfitMarginChartSkeleton: React.FC = () => {
  return (
    <div className="rounded-xl bg-white/80 border p-4 shadow-sm h-80">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <SkeletonBlock className="h-4 w-32" />
      </div>

      {/* Chart area */}
      <div className="h-64 flex items-end gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <SkeletonBlock
            key={i}
            className="w-full max-w-[32px]"
            // style={{
            //   height: `${30 + i * 15}px`,
            // }}
          />
        ))}
      </div>
    </div>
  );
};

export default ProfitMarginChartSkeleton;
